let redirecting = false

export function isRedirecting(): boolean {
    return redirecting
}

export function setRedirecting(value: boolean): void {
    redirecting = value
}
